import { isTimeTrackerComponent } from '@shared/scenes/workflows/utils';
import { API } from '@shared/types/api';

/**
 * Whether a timer offers its start/stop button: only where the card can be updated, and not on a
 * read-only timer.
 */
export function canStartStopTimer(component: API.AnyComponent, canUpdateCard: boolean): boolean {
  return isTimeTrackerComponent(component) && canUpdateCard && !component.readonly;
}
